/* tslint:disable */
/* eslint-disable */
/**
 * Selling Partner API for Product Type Definitions
 * The Selling Partner API for Product Type Definitions provides programmatic access to attribute and data requirements for product types in the Amazon catalog. Use this API to return the JSON Schema for a product type that you can then use with other Selling Partner APIs, such as the Selling Partner API for Listings Items, the Selling Partner API for Catalog Items, and the Selling Partner API for Feeds (for JSON-based listing feeds).  For more information, see the [Product Type Definitions API Use Case Guide](https://developer-docs.amazon.com/sp-api/docs/product-type-api-use-case-guide).
 *
 * The version of the OpenAPI document: 2020-09-01
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import type { ProductTypeVersion } from './product-type-version.js';
// May contain unused imports in some cases
// @ts-ignore
import type { PropertyGroup } from './property-group.js';
// May contain unused imports in some cases
// @ts-ignore
import type { SchemaLink } from './schema-link.js';

/**
 * A product type definition represents the attributes and data requirements for a product type in the Amazon catalog. Product type definitions are used interchangeably between the Selling Partner API for Listings Items, Selling Partner API for Catalog Items, and JSON-based listings feeds in the Selling Partner API for Feeds.
 */
export interface ProductTypeDefinition {
    'metaSchema'?: SchemaLink;
    'schema': SchemaLink;
    /**
     * Name of the requirements set represented in this product type definition.
     */
    'requirements': ProductTypeDefinitionRequirementsEnum;
    /**
     * Identifies if the required attributes for a requirements set are enforced by the product type definition schema. Non-enforced requirements enable structural validation of individual attributes without all of the required attributes being present (such as for partial updates).
     */
    'requirementsEnforced': ProductTypeDefinitionRequirementsEnforcedEnum;
    /**
     * Mapping of property group names to property groups. Property groups represent logical groupings of schema properties that can be used for display or informational purposes.
     */
    'propertyGroups': { [key: string]: PropertyGroup; };
    /**
     * Locale of the display elements contained in the product type definition.
     */
    'locale': string;
    /**
     * Amazon marketplace identifiers for which the product type definition is applicable.
     */
    'marketplaceIds': Array<string>;
    /**
     * The name of the Amazon product type that this product type definition applies to.
     */
    'productType': string;
    /**
     * Human-readable and localized description of the Amazon product type.
     */
    'displayName': string;
    'productTypeVersion': ProductTypeVersion;
}

export const ProductTypeDefinitionRequirementsEnum = {
    Listing: 'LISTING',
    ListingProductOnly: 'LISTING_PRODUCT_ONLY',
    ListingOfferOnly: 'LISTING_OFFER_ONLY',
} as const;

export type ProductTypeDefinitionRequirementsEnum = typeof ProductTypeDefinitionRequirementsEnum[keyof typeof ProductTypeDefinitionRequirementsEnum];
export const ProductTypeDefinitionRequirementsEnforcedEnum = {
    Enforced: 'ENFORCED',
    NotEnforced: 'NOT_ENFORCED',
} as const;

export type ProductTypeDefinitionRequirementsEnforcedEnum = typeof ProductTypeDefinitionRequirementsEnforcedEnum[keyof typeof ProductTypeDefinitionRequirementsEnforcedEnum];


